import init from '@/lib/utils/_init'

const circleBranch = process.env.CIRCLE_BRANCH

const envObj = {
  API_URL: process.env.API_URL || '',
  APP_URL: process.env.APP_URL || 'http://localhost:8081',

  EMAIL_RECIPIENTS: process.env.EMAIL_RECIPEINTS || '',

  GTM_CONTAINER_ID: '',
  COOKIE_BANNER_ID: '',

  IS_DEV: process.env.NODE_ENV === 'development',
  IS_PROD: false,

  GOOGLE_SEARCH_CONSOLE: process.env.NEXT_PUBLIC_GOOGLE_SEARCH_CONSOLE || '',
}

if (circleBranch === 'production') {
  envObj.GTM_CONTAINER_ID = process.env.GTM_CONTAINER_ID || ''
  envObj.COOKIE_BANNER_ID = process.env.COOKIE_BANNER_ID || ''
  envObj.GOOGLE_SEARCH_CONSOLE = process.env.NEXT_PUBLIC_GOOGLE_SEARCH_CONSOLE || '',
  envObj.IS_PROD = true
}

init(envObj.API_URL)

export default { ...envObj }
